import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from '@lodash';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FuseAnimate from '@fuse/core/FuseAnimate';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import Tooltip from '@material-ui/core/Tooltip';
import { formatUserFullName } from 'app/main/utils/usersUtils';
import { selectUsers, selectUserById } from 'app/main/settings/store/usersSlice';
import { COMPENSATION_ROLES, isLoanOfficerAssistant } from 'app/constants/compensation';
import { getEventCompensationForEmployee } from 'app/main/closing-board/store/eventSlice';

const useStyles = makeStyles({
  selectBackupAssistant: {
    minWidth: '15em'
  }
});

function AddBackupAssistantButton(props) {
  const classes = useStyles(props);
  const employees = _.cloneDeep(props.value);
  const dispatch = useDispatch();

  const users = useSelector(selectUsers);

  const [selectedBackupAssistant, setSelectedBackupAssistant] = useState('');
  const [addBackupAssistant, setAddBackupAssistant] = useState(false);

  const pickedUser = useSelector(state => selectUserById(state, selectedBackupAssistant));
  const closingEvent = useSelector(({ closingEvents }) => _.get(closingEvents, 'event.payload'));
  const compensations = useSelector(({ closingEvents }) => _.get(closingEvents, 'event.compensations'));

  const handleBackupAssistant = event => setSelectedBackupAssistant(event.target.value);

  const handleNewBackupAssistant = () => {
    const payload = { eventId: closingEvent.id, userId: pickedUser.id, userRole: COMPENSATION_ROLES.LOAN_OFFICER_ASSISTANT };
    dispatch(getEventCompensationForEmployee(payload));

    setAddBackupAssistant(false);
    setSelectedBackupAssistant(null);
  };

  const isBackupAssistantAvailable = u => {
    if (isLoanOfficerAssistant(u)) {
      return !employees.find(loa => loa.employeeId === u.id);
    }
    return false;
  };

  useEffect(() => {
    if (!compensations) {
      return;
    }
    const newList = [...employees];
    const found = _.find(newList, e => e.employeeId === compensations.userId);
    if (found) {
      return;
    }
    const newBackupAssistant = {
      employeeId: compensations.userId,
      employeeRole: COMPENSATION_ROLES.BACKUP_ASSISTANT,
      amount: compensations.value,
      paymentDate: null,
      payerId: null,
      updatedDate: new Date(),
      assigned: true
    };

    newList.push(newBackupAssistant);
    props.onChange({ target: { name: props.name, value: newList } });
  }, [compensations, employees, props]);

  return (
    <>
      {addBackupAssistant && (
        <div>
          <FormControl required variant="outlined" className={clsx('mr-20 mt-8 mb-16', classes.selectBackupAssistant)}>
            <InputLabel className="mb-10" htmlFor="backupAssistant">
              Backup Assistant
            </InputLabel>
            <Select
              required
              id="backupAssistant"
              name="backupAssistant"
              displayEmpty={false}
              defaultValue=""
              placeholder="Select Backup Assistant"
              label="Backup Assistant"
              value={selectedBackupAssistant}
              onChange={handleBackupAssistant}
            >
              {users &&
                users
                  .filter(backupAssistant => isBackupAssistantAvailable(backupAssistant))
                  .map(backupAssistant => (
                    <MenuItem key={backupAssistant.id} value={backupAssistant.id}>
                      {formatUserFullName(backupAssistant)}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
          <Tooltip title="Cancel" placement="bottom">
            <span>
              <IconButton
                aria-label="cancel"
                className={classes.margin}
                onClick={() => {
                  setAddBackupAssistant(false);
                  setSelectedBackupAssistant(null);
                }}
              >
                <CloseIcon fontSize="large" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Submit" placement="bottom">
            <span>
              <IconButton
                aria-label="submit"
                disabled={!selectedBackupAssistant}
                className={classes.margin}
                onClick={handleNewBackupAssistant}
              >
                <DoneIcon fontSize="large" />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      )}
      <div>
        <FuseAnimate animation="transition.slideRightIn" delay={300}>
          <Button
            onClick={() => setAddBackupAssistant(!addBackupAssistant)}
            disabled={addBackupAssistant}
            className="whitespace-no-wrap normal-case"
            variant="contained"
            color="inherit"
            startIcon={<AddIcon />}
          >
            <span className="hidden sm:flex">Add Backup Assistant</span>
          </Button>
        </FuseAnimate>
      </div>
    </>
  );
}

export default AddBackupAssistantButton;
